import { useRouteMatch } from 'react-router-dom';
import { Path } from 'urlBuilder';

import { WizardStep } from '../../../resources/constants';

export const useWizardActiveStep = () => {
    const match = useRouteMatch<{ step: Exclude<WizardStep, WizardStep.UserInfo> }>(
        `/:companyId/${Path.walletsKycWizard}/:step`
    );

    return match?.params.step;
};
